module.exports = __webpack_public_path__ + "img/box-arrow-in-up-left.4f432c4b.svg";